import React, {  useState, useContext } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
//import useStateWithCallback from 'use-state-with-callback'
import { StyleSheet, ScrollView, View, Text, Image, TouchableOpacity } from "react-native";
import * as Yup from "yup";
import * as ImageManipulator from "expo-image-manipulator"
import { MaterialCommunityIcons } from "@expo/vector-icons"
import Screen from "../components/Screen";
//import settingStorage from "../config/settingStorage";
import connectionConfig from "../config/settings";
import AuthContext from "../auth/context";

import {
  ErrorMessage,
  FormPicker as Picker,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
import dateNow from "../utility/dateNow";
import * as ImagePicker from "expo-image-picker"
import colors from "../config/colors";
import storage from "../auth/storage";
var settingStorage = {
  json: {
      country: '',
      userId: '',
      userName: '',
      email: '',
      userPhoto: '',
      userPassword: '',
      createDate: '',
      countryId: '',
      country: '',
      alias: ''
  },
  KEY: 'fixo.charly'
}
var isSubmited = false
var date = dateNow()
const validationSchema = Yup.object().shape({
  userName: Yup.string().required().label("Name"),
  alias: Yup.string().required().label("Alias"),
  email: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(4).label("Password"),
  // images: Yup.array().min(1, "Please select at least one image."),
});
//debugger
function RegisterScreen() {

  const [error, setError] = useState();
  const [country, setCountry] = useState('')
  const [refresh, setRefresh] = useState(0)
  const [insertFailed, setInsertFailed] = useState(false)
  const [selectFailed, setSelectFailed] = useState(false);
  const [imageUri, setimageUri] = useState('')
  const { user, setUser } = useContext(AuthContext);
  var insert_user_fixo = []
  var select_user_fixo = []
  var error_message = '';
  var errorValidation = false
 
   //-----------------------------------------------------------------------------
  //1. Servicio que valida que el email de usuario no exista en la base de datos.
  //------------------------------------------------------------------------------
  const handlerSubmitSelectEmailUser = async ({
    userName,
    password,
    email,
    userPhoto,
    alias
  }) => {
    //debugger
    var post_values = { email: email }
    //establece parámetros de configurción del post 
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
   
    //solicita el servicio para traer los datos del usuario 
    await fetch(connectionConfig.apiUrl + '/selectValidateEmailUser', configurationPost)
      .then(response => response.json())
      .then(response => {
        if (response.data.length === 0) {
          selectAliasUser(
            userName,
            password,
            email,
            userPhoto,
            alias
          )
        } else {
          //console.log('emplo de -> true', response.data)
          alert('Por favor revisa tu email de usuari, alguien ya utilizo ese email en Fixo. ', ['Accept'])
         // err = true
        }
      })
      .catch(err => {
        console.log('Select email fixo failed :( review internet service -> /selectValidateEmailUser', err)
      })
  }
  //--------------------------------------------------------------------------
  //2. Servicio que valida que el alias de usuario no exista en la base de datos
  //--------------------------------------------------------------------------
  const selectAliasUser = async (
    userName,
    password,
    email,
    userPhoto,
    alias
  ) => {
    var post_values = {
      alias: alias
    }
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
    await fetch(connectionConfig.apiUrl + '/selectValidateAliasUser', configurationPost)
      .then(response => response.json())
      .then(response => {
        if (response.data.length === 0) {
          handleSubmit(userName,
            password,
            email,
            userPhoto,
            alias)
        } else {
          alert('Por favor revisa tu alias de usuario, alguien ya se nombro así en Fixo. ', ['Accept'])
        }
      })
      .catch(err => {
        console.log(':( review internet service /selectValidateAliasUser/', err)
      })
  }
  //---------------------------------------------
  //3. Agrega un nuevo usuario a base de datos users
  //--------------------------------------------- 
  const handleSubmit = async (
    userName,
    password,
    email,
    userPhoto,
    alias
  ) => {
    //debugger
    //obtiene el valor de los roles seleccionados
    var json = {}
    await AsyncStorage.getItem(settingStorage.KEY)
      .then(value => {
        if (value) {
          json = JSON.parse(value)
          //console.log('valor json ->', json)
        }
      })
    //validaciones de campos submit
    if (imageUri === '') {
      alert('Elige una Imagen, es importante para tu perfil ', ['Accept'])
      errorValidation = true
    }

    // if (country.length === 0) {
    //   errorValidation = true
    // }
    // selectAliasUser(alias)
    // if (select_user_alias === true) {
    //   errorValidation = true
    // }
    // handlerSubmitSelectEmailUser(email)
    // if (select_user_email_fixo === true) {
    //   console.log('entre a  -> select_user_email_fixo', select_user_email_fixo)
    //   errorValidation = true
    // }
    isSubmited = true
    if (errorValidation === true) {
      setRefresh(refresh + 1)
      console.log("entre a errorValidation ->", errorValidation)
    } else {
      //console.log("entre a insert")
      setInsertFailed(false);
      var post_values = {
        userName: userName,
        email: email,
        userPhoto: date.replace(/ /g, '_').replace(/\//g, '-') + '_photo.jpg',
        userPassword: password,
        createDate: date,
        country: json.country,
        alias: alias,
      }
      //establece parámetros de configurción del post 
      var configurationPost = {
        method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, *.*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(post_values)
      }
      //solicita el servicio para login fixo remoto
      await fetch(connectionConfig.apiUrl + '/fixoUsers/insert/', configurationPost)
        .then(response => response.json())
        .then(response => {
          insert_user_fixo = response.data
        })
        .catch(err => {
          console.log('Insert fixo failed :( review internet service', err)
          setInsertFailed(true);
        })
      if (insertFailed === false) {
        if (insert_user_fixo.length === 0 || insert_user_fixo === 'error en query') {
          error_message = 'Invalid insert.'
          console.log(error_message)
        } else {
          //console.log('insert users fixo success ;) ', insert_user_fixo)
          savePhoto(insert_user_fixo.insertId, userPhoto)
          selectUserCreated(insert_user_fixo.insertId)
          //resetForm();
        }
      }
    }
  };

  //---------------------------------------------------
  //4. Servicio que obtiene al usuario depues de creado
  //---------------------------------------------------
  async function selectUserCreated(insertId) {
    setSelectFailed(false)
    select_user_fixo = []
    var post_values = { insertId: insertId }
    //establece parámetros de configurción del post 
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
    //solicita el servicio para traer los datos del usuario 
    await fetch(connectionConfig.apiUrl + '/selectUser', configurationPost)
      .then(response => response.json())
      .then(response => {
        //console.log('resultado selectUser', response)
        select_user_fixo = response.data
      })
      .catch(err => {
        console.log('Insert fixo failed :( review internet service /selectUser', err)
        setSelectFailed(true);
      })
    if (selectFailed === false) {
      if (select_user_fixo.length === 0 || select_user_fixo === 'error en query') {
        error_message = 'Invalid SelectUser.'
        console.log(error_message)
      } else {
        // se guarda la información del usuario creado 
        settingStorage.json.country = select_user_fixo[0].country
        settingStorage.json.userId = select_user_fixo[0].userId
        settingStorage.json.alias = select_user_fixo[0].alias
        settingStorage.json.userName = select_user_fixo[0].userName
        settingStorage.json.userPhoto = select_user_fixo[0].userPhoto
        settingStorage.json.email = select_user_fixo[0].email
        settingStorage.json.createDate = select_user_fixo[0].createDate

      //  await AsyncStorage.setItem(settingStorage.KEY, JSON.stringify(settingStorage.json))
        const userInformation = JSON.stringify(settingStorage.json)

        //Esta función se encarga de guardar los datos de seción del usuario creado
        storage.storeToken(userInformation)
        settingStorage = [] 
        setUser(userInformation)
      }
    }
  }

  var handleSelectCountry = async (countryCode) => {
    setCountry(countryCode)
    //debugger
    settingStorage.json.country = countryCode
    await AsyncStorage.setItem(settingStorage.KEY, JSON.stringify(settingStorage.json))
  }

  //--------------------------------------------
  //rutina que guarda fotos de perfil de usuario
  //--------------------------------------------
  const savePhoto = async (userId) => {

    let format = 'JPEG'
    let quality = 0.1
    const manipResult = await ImageManipulator.manipulateAsync(
      imageUri,
      [],
      { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
     debugger
    //         //setCache(manipResult.uri)
    //setFinalUri(manipResult.uri)
    let index = manipResult.uri.lastIndexOf('/')
    let fileName = manipResult.uri.substring(index + 1)
   // debugger
    try {
      const nameDatePhoto = userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_photo.jpg'
      const formData = new FormData()
      formData.append('photo', {
        uri: manipResult.uri,
        type: 'image/jpg',
        name: nameDatePhoto
      })
      const configurationPost = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        body: formData
      }
      // post Para guardar imagen de perfil
      fetch(connectionConfig.apiUrl + '/native_upload_single', configurationPost)
        .then(response => response.json())
        .then(response => {
          //debugger
          if (response.data === 'descarga-> error') {
            console.log(" maintennance server -> please try later /native_upload_single", response, dta)
          }
        })
        .catch((err) => {
          console.log("maintennance server -> please try later ctach /native_upload_single", err)
        })
    } catch (error) {
      console.log("maintennance server -> ctach del catch please try later /native_upload_single", error)
    }
  }

  const selectImage = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync()
      if (!result.cancelled)
        setimageUri(result.uri)
    } catch (error) {
      console.log("error al leer imagen", error)
    }
  }

  return (
    <>
    <Screen style={styles.container}>
      <ScrollView scrollToEnd={({ animated: false })}>
        {/* <ActivityIndicator visible={registerApi.loading || loginApi.loading} /> */}

        <Form
          initialValues={{
            userName: "Carlos Arturo",
            email: "a@gmail.com",
            password: "12345",
            alias: 'alguiño',
            userPhoto: []
          }}
          onSubmit={handlerSubmitSelectEmailUser}
          validationSchema={validationSchema}
        >
          <ErrorMessage error={error} visible={error} />
          <Text style={styles.txtTitle}>Nombre de usuario</Text>
          <FormField
            autoCorrect={false}
            icon="account"
            name="userName"
            placeholder="Name"
          />

          <Text style={styles.txtTitle}>Alias de usario</Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="guy-fawkes-mask"
            name="alias"
            placeholder="Alias"
            size={30}
          />
          <Text style={styles.txtTitle}>Email</Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="email"
            keyboardType="email-address"
            name="email"
            placeholder="Email"
            textContentType="emailAddress"
          />
          <Text style={styles.txtTitle}>Contraseña</Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="lock"
            name="password"
            placeholder="Password"
            secureTextEntry
            textContentType="password"
          />

          <Text style={styles.txtFoto}>Foto de perfil</Text>
          <TouchableOpacity onPress={selectImage}>
            {imageUri != '' ?
              <Image style={styles.imagePhoto} source={{ uri: imageUri }} />
              :
              <MaterialCommunityIcons
                style={styles.image}
                name="camera"
                size={120}
                color={colors.medium}
              />
            }
          </TouchableOpacity>
          <SubmitButton txtStyle={styles.txtSubmit}
            btnStyle={styles.btnSubmit}
            color={'pistache'}
            title={"Crear usuario"}
          />
        </Form>
      </ScrollView>
    </Screen>
  </>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  errorValidation: {
    color: 'red'
  },
  imagePhoto: {
    width: 200,
    height: 200,
    alignSelf: "center",
    marginTop: '3%',
    marginBottom: 20,
    marginLeft: '3%',
    borderRadius: 5,
  },
  image: {
    marginLeft: '33%',
  },
  txtTitle: {
    marginLeft: "5%",//20,

  },
  txtFoto: {
    marginTop: '3%',
    marginLeft: "38%",//20,

  },
  txtTitle: {
    marginLeft: "5%",//20,

  },
  txtSubmit: {
    marginLeft: "15%",//20,
    color: colors.green,
    fontSize: 18,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  btnSubmit: {
    marginLeft: "24%",//20,
    width: '55%',
    height: '7%',
    borderRadius: 10,
    paddingTop: 13,
    marginBottom: 20
  },
  //camera styles
  camera: {
    flex: 1,
  },
  buttonContainer: {
    flex: 1,
    backgroundColor: 'transparent',
    flexDirection: 'row',
    margin: 20,
  },
  button: {
    flex: 0.1,
    alignSelf: 'flex-end',
    alignItems: 'center',
  },
  text: {
    fontSize: 18,
    color: 'white',
  },
});

export default RegisterScreen;
